import { createRef } from 'react';

import { AudioCallContentMethods, AudioRouteButtonMethods } from './_types';

export const audioCallContentRef = createRef<AudioCallContentMethods>();
export const audioRouteButtonRef = createRef<AudioRouteButtonMethods>();
export const audioCallRemoteVideoRef = createRef<HTMLVideoElement>();
